<template>
  <div class="OtherEmployeurs" >
    <section id='form-section-banner' :style="{ backgroundImage: 'url(' + require('@/assets/images/camera_banner.jpg') + ')' }">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="form-section-banner-title">
              Employeurs
            </h1>
          </div>
        </div>
      </div>
    </section>
      <div class="container">
        <div class="form_div">
          <div class="form_content">
              <h2>
                Autres services partagés
              </h2>
              <p>
                Vous trouverez sur cette page l'ensemble des autres services partagés proposés pour vous soutenir.<br>
                <em>Cliquez sur les mesures pour accéder à leur contenu</em>
              </p>

              <h3>
                Gestion sociale et RH pratique
              </h3>

              <div class="row mt-2">
                <div class="col-12">
                  <ol class="gradient-list">
                    <li>
                      <a class="aide-link" href='https://www.audiens.org/accueil/actualites/actus-audiens/listeactusaudiens/web-conferences-audiens.html' target="_blank">
                        <strong>Web-conférences de veille sociale</strong>
                      </a> : aides de l'état, chômage, gestion de la paie, portabilité des droits prévoyance et santé
                    </li>
                    <li><a class="aide-link" href='https://www.audiens.org/files/live/sites/siteAudiens/files/03_documents/entreprise/Fiches-techniques/Fiche-service-3-18_SSIE-2020.pdf' target="_blank">
                      <strong>Le Service Social Inter-entreprises</strong>
                    </a> : des assistant.e.s sociaux.les pour accompagner vos salariés en difficulté
                    </li>
                    <li>
                      Les
                      <a class="aide-link" href='https://bilan.pole-sante-bergere.org/' target="_blank">
                        <strong>bilans de prévention santé</strong>
                      </a> pour vos salariés au <strong>Pôle santé Bergère d'Audiens</strong>
                    </li>
                    <li>
                      <strong>Accompagner les entreprises dans leurs transformations</strong> :
                      <a class="aide-link" href="https://www.afdas.com/entreprises/services/professionnaliser/prestations-appui-conseil" target="_blank">
                        les appuis conseils
                      </a>
                    </li>
                    <li>
                      <a class="aide-link" href='https://collection.afdas.com/' target="_blank">
                        La collection entreprise : <strong>les essentiels et les intégrales</strong>
                      </a> sur l'alternance, les entretiens pros, la certification…
                    </li>
                    <li>
                      <a class="aide-link" href='https://www.audiens.org/files/live/sites/siteAudiens/files/03_documents/entreprise/Guides%20pratiques/Guide-pratique-Audiens_avril-2020.pdf' target="_blank">
                        <strong>Le guide pratique de l'entreprise</strong>
                      </a>
                    </li>
                  </ol>
                </div>
              </div>


              <h3>
                Formation à distance
              </h3>

              <div class="row mt-2">
                <div class="col-12">
                  <ol class="gradient-list">
                    <li>
                      <a class="aide-link" href=' https://www.afdas.com/images/guide-pratique-pour-acheter-une-formation-a-distance.pdf' target="_blank">
                        <strong>Guide pratique</strong>
                      </a> pour acheter une formation à distance
                    </li>
                    <li>
                      <a class="aide-link" href='https://www.afdas.com/offres-formation-distanciel-entreprises-particuliers#des-offres-de-formation-a-distance-pour-tous' target="_blank">
                        Une sélection d'<strong>offres de formation</strong>
                      </a> clés en main 100% à distance
                    </li>
                    <li>
                      <a class="aide-link" href='https://www.afdas.com/offres-formation-distanciel-entreprises-particuliers#une-liste-des-offres-a-distance-du-marche' target="_blank">
                        Liste des <strong>offres de formation à distance</strong> sur le marché
                      </a> : 185 organismes de formation référencés par thématique d'intervention
                    </li>
                  </ol>
                </div>
              </div>

              <h3>
                Risques professionnels et santé au travail
              </h3>

              <div class="row mt-2">
                <div class="col-12">
                  <ol class="gradient-list">
                    <li>
                      <a class="aide-link" href='mailto:intervention@cmb-sante.fr' target="_blank">
                        <strong>Diagnostics risques sur lieux de travail</strong>
                      </a> (ergonomie, hygiène sécurité et environnement, risque chimique...)
                    </li>
                    <li>
                      <a class="aide-link" href='http://www.cmb-sante.fr/document-unique-employeurs_151_574.html' target="_blank">
                        Aide à l'actualisation du <strong>Document Unique d'Evaluation des Risques Professionnels</strong>
                      </a> sur l'outil ODALIE
                    </li>
                    <li>
                      <a class="aide-link" href='http://www.cmb-sante.fr/_upload/ressources/06espace_pratique/062prevention_pratique/guide-du-cirque-2019-partie1.pdf' target="_blank">
                        <strong>Mise à disposition de guides spécifiques</strong>
                      </a> : troubles musculo-squelettiques des artistes, guide cirque, harcèlement sexuel et agissements sexistes
                    </li>
                    <li>
                      <a class="aide-link" href="http://www.cmb-sante.fr/suivi-de-vos-salari%C3%A9s-employeurs_151_221.html" target="_blank">
                        <strong>Suivi en santé au travail</strong>
                      </a>
                      des salariés intermittents du spectacle (France entière) et des salariés permanents (Ile-de-France)
                    </li>
                    <li>
                      <a class="aide-link" href='mailto:covid19-ids@cmb.asso.fr'>
                        <strong>Cellules ad hoc</strong> créées en lien avec les évènements du secteur
                      </a> : écoute psycho-sociale, groupe COVID
                    </li>
                  </ol>
                </div>
              </div>


              <h3>
                Accompagnement alternance
              </h3>

              <div class="row mt-2">
                <div class="col-12">
                  <ol class="gradient-list">
                    <li>
                      <a class="aide-link" href='https://www.afdas.com/actualites/lafdas-est-a-votre-ecoute' target="_blank">
                        <strong>Allo TPE Alternance</strong>
                      </a> : des conseillers emplois formation dédiés au plus près des TPE pour les accompagner sur leurs projets d'alternance
                    </li>
                    <li>
                      <a class="aide-link" href='https://www.youtube.com/watch?v=XSKkegWT3-c&feature=youtu.be' target="_blank">
                        <strong>Matinale/web-conférence Alternance</strong>
                      </a>
                    </li>
                    <li>
                      <a class="aide-link" href='https://www.audiens.org/solutions/accompagnement-salarie-retour-a-l-emploi.html?univers=p---votre-parcours-professionnel' target="_blank">
                        <strong>Accompagnement social des alternants</strong>
                      </a> : plateforme d'information sociale et aide financière à la mobilité
                    </li>
                  </ol>
                </div>
              </div>


              <h3>
                Accompagnement Handicap
              </h3>

              <div class="row mt-2">
                <div class="col-12">
                  <ol class="gradient-list">
                    <li>
                      <a class="aide-link" href=' http://missionh-spectacle.fr/' target="_blank">
                        Actions de soutien à la <strong>gestion de l'OETH</strong>
                      </a>
                    </li>
                    <li>
                      <a class="aide-link" href='http://missionh-spectacle.fr/' target="_blank">
                        <strong>Sensibilisation et information Handicap</strong>
                      </a>
                    </li>
                    <li>
                      <a class="aide-link" href='http://missionh-spectacle.fr/' target="_blank">
                        <strong>Recrutement, maintien dans l'emploi,</strong> recours à la <strong>sous-traitance</strong> avec le secteur du travail adapté et protegé
                      </a>
                    </li>
                    <li>
                      <a class="aide-link" href='http://www.cmb-sante.fr/maintien-en-emploi_espace-pratique_1233.html' target="_blank">
                        Plateforme de <strong>prévention de la désinsertion professionnelle</strong>
                      </a>
                    </li>
                  </ol>
                </div>
              </div>

              <b-button @click="goToCovidEmployeurs" size="lg" pill block variant="outline-primary">Accéder aux mesures spéciales COVID</b-button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OtherEmployeurs',
  methods: {
    goToCovidEmployeurs () {
       this.$router.push('/covid/employeurs')
    },
  }
}
</script>

<style lang="scss">
/*** EXTEND ***/
/* box-shadow */
%boxshadow {
  box-shadow: 0.25rem 0.25rem 0.6rem rgba(0,0,0,0.05), 0 0.5rem 1.125rem rgba(75,0,0,0.05);
}

/*** STYLE ***/

*,
*:before,
*:after {
  box-sizing: border-box;
}

.aide-link {
  text-decoration: none;
}



ol.gradient-list {
  counter-reset: gradient-counter;
  list-style: none;
  margin: 1.75rem 0;
  padding-left: 1rem;
  > li {
    background: white;
    border-radius: 0 0.5rem 0.5rem 0.5rem;
    @extend %boxshadow;
    counter-increment: gradient-counter;
    margin-top: 1rem;
    min-height: 2rem;
    padding: 1rem 1rem 1rem 3rem;
    position: relative;
    &::before,
    &::after {
      background-color: #d6075b;
      content: '';
      height: 2rem;
      left: -0.5rem;
      overflow: hidden;
      position: absolute;
      top: -0.5rem;
      width: 2rem;
    }
    &::before {
      align-items: flex-end;
      @extend %boxshadow;
      content: counter(gradient-counter);
      color: #1d1f20;
      display: flex;
      font-weight: 800;
      color: white;
      justify-content: flex-end;
      padding: 0.23em 0.7em;
      z-index: 1;
    }

    + li {
      margin-top: 2rem;
    }
  }
}


</style>
